/**
 * @author alteredq / http://alteredqualia.com/
 * Mods by garyo@darkstarsystems.com
 */

import {Scene, Camera, Material, Color, WebGLRenderer, WebGLRenderTarget} from 'three'
import {Pass} from "three/examples/jsm/postprocessing/Pass.js"

export type RenderCallback = (renderPass: RenderPass, renderer: WebGLRenderer) => void

/** RenderPass for three.js EffectComposer - Horizon custom version */
export class RenderPass extends Pass {
  scene: Scene
  camera: Camera
  renderCallback?: RenderCallback
  overrideMaterial?: Material
  clearColor?: Color
  clearAlpha?: number

  clear = true
  clearDepth = false
  needsSwap = false

  renderArgs: any // can store anything here so the render callback can use it

  constructor(scene: Scene,
              camera: Camera,
              renderCallback?: RenderCallback,
              overrideMaterial?: Material,
              clearColor?: Color,
              clearAlpha?: number) {

    super()
    this.scene = scene
    this.camera = camera
    this.renderCallback = renderCallback
    this.overrideMaterial = overrideMaterial
    this.clearColor = clearColor
    this.clearAlpha = clearAlpha || 0
  }

  // called by composer
  render(renderer: WebGLRenderer,
         _writeBuffer: WebGLRenderTarget,
         readBuffer: WebGLRenderTarget,
         _deltaTime: number,
         _maskActive: boolean) {

    let oldClearColor, oldClearAlpha, oldOverrideMaterial;
    const oldAutoClear = renderer.autoClear;
    renderer.autoClear = false;
    if (this.overrideMaterial !== undefined) {
      oldOverrideMaterial = this.scene.overrideMaterial;
      this.scene.overrideMaterial = this.overrideMaterial;
    }
    if (this.clearColor) {
      oldClearColor = renderer.getClearColor().getHex();
      oldClearAlpha = renderer.getClearAlpha();
      renderer.setClearColor(this.clearColor, this.clearAlpha);
    }
    if (this.clearDepth)
      renderer.clearDepth();

    renderer.setRenderTarget(this.renderToScreen ? null : readBuffer);

    if (this.clear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);

    // Use renderCallback if set; it should call renderer.render
    if (this.renderCallback)
      this.renderCallback(this, renderer)
    else
      renderer.render(this.scene, this.camera);

    if (oldClearColor)
      renderer.setClearColor(oldClearColor, oldClearAlpha);
    if (oldOverrideMaterial !== undefined)
      this.scene.overrideMaterial = oldOverrideMaterial;
    renderer.autoClear = oldAutoClear;
  }
}
